import { ReactElement } from 'react';

import { TranslatableText } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';

import { invoiceTranslationKeys } from '../translations';

import { InvoicePanel } from './InvoicePanel';

type InvoiceNavTab<PARAM_NAME extends string> = {
   param: PARAM_NAME;
   label: TranslatableText;
   content: ReactElement;
};

type UseInvoiceNavTabOptions<PARAM_NAME> = {
   param: PARAM_NAME;
};

export const useInvoiceNavTab = <PARAM_NAME extends string>(
   options: UseInvoiceNavTabOptions<PARAM_NAME>
): InvoiceNavTab<PARAM_NAME> | null => {
   return protectFeature(
      'managingInvoices',
      {
         content: <InvoicePanel />,
         label: invoiceTranslationKeys.tabName,
         param: options.param,
      },
      null
   );
};

export const openUrlInNewTab = (url: string) => (): void => {
   window.open(url, '_blank');
};
